/** Route builders for the pipeline pages, which live under /models (TRA-863). */

import type { BatchResponse } from '@/api/generated/model'

export function pipelinePath(name: string): string {
  return `/models/pipelines/${name}`
}

export function batchPath(batch: Pick<BatchResponse, 'pipeline' | 'id'>): string {
  return `/models/pipelines/${batch.pipeline}/batches/${batch.id}`
}
